import 'console-shim';

import {LocalizationContext, mergeLocalizationDataAltStore} from '@epic-core/localization';

import App from './App';
import {decode} from '../server/utils/encode'
import {BrowserRouter} from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import alt from './alt';
import root from 'window-or-global';
import {setLocale} from '@epic-core/common';

/**
 * The react app will look for a DOM element with this ID and insert itself there.
 */
const reactDomEle = root.document.getElementById('unrealtournamentReactWrapper');
const preload = decode(root.__epic_client_state)
const i18nContext = mergeLocalizationDataAltStore(preload.LocalizationStore);
const renderClient = function renderClient() {
    ReactDOM.hydrate((
        <BrowserRouter>
            <ScrollToTopOnUpdate>
                <LocalizationContext.Provider value={i18nContext}>
                    <App />
                </LocalizationContext.Provider>
            </ScrollToTopOnUpdate>
        </BrowserRouter>
    ), reactDomEle);
};

// only proceed if the react ele exists
if (reactDomEle) {
    if (preload) {
        setLocale(root.__locale);
        alt.bootstrap(preload);
    }
    renderClient();
}
